 // ToggleTable.js
 import React, { useState, useEffect,useContext, useRef  } from "react";
 import "bootstrap/dist/css/bootstrap.min.css";
 import { useNavigate   } from 'react-router-dom';
 import Navbar from './Navbar';
 import axios from 'axios';
 import Loader from '../components/Loader';
 import { UserContext } from '../contexts/UserContext';
 import FeedbackWidget from '../components/FeedbackWidget';
 import { CONFIG} from '../config';
 
 const TableWithSortAndColBorders = ({ tableTitle,tableData, columns }) => {
   const [showA, setShowA] = useState(false);
   const [showB, setShowB] = useState(false);
   const [offsetTopA, setOffsetTopA] = useState(0);
   const [offsetTopB, setOffsetTopB] = useState(0);
   const [filterModal, setFilterModal] = useState({});
   const [searchText, setSearchText] = useState({});
   const [selectedValues, setSelectedValues] = useState({});
   const [sortColumn, setSortColumn] = useState("workstream_type");
   const [tempSelectedValues, setTempSelectedValues] = useState({});
   
 
   const scrollContainerRef = useRef(null);
 
   const toggleA = () => setShowA((prev) => !prev);
   const toggleB = () => setShowB((prev) => !prev);
 
   const allColumnValues = (key) => {
     if (!tableData || !Array.isArray(tableData)) return [];
     return [...new Set(tableData.map((item) => item[key]).filter(Boolean))];
   };
 
   const priority = {
     'Mandatory': 1,
     'Recommended': 2,
     'Optional': 3
   };
 
   const filteredData = (tableData || []).filter((item) =>
    columns.every(({ key }) => {
      const selected = selectedValues[key] || [];
      const itemValue = item[key]?.toString().trim(); // 👈 trim the data value
      return selected.length === 0 || selected.includes(itemValue);
    })
  );
 
   if (sortColumn) {
   
    filteredData.sort((a, b) => {
    // 1️⃣ Primary: user-selected column
    const primary = a[sortColumn]?.toString().localeCompare(b[sortColumn]?.toString());
    if (primary !== 0) return primary;

    // 2️⃣ Secondary: workstream_type
    const wtComparison = a.workstream_type.localeCompare(b.workstream_type);
    if (wtComparison !== 0) return wtComparison;

    // 3️⃣ Third: type (priority based)
    const applicabilityComparison = (priority[a.applicability] || 99) - (priority[b.applicability] || 99);
    if (applicabilityComparison !== 0) return applicabilityComparison;
    
    // 4️⃣ Fourth: metric_name again for complete uniqueness
    return a.metric_name.localeCompare(b.metric_name);
  });
   }
 
   useEffect(() => {
     const handleScroll = () => {
       const container = scrollContainerRef.current;
       if (container) {
         const center = container.scrollTop -400 + container.clientHeight / 2;
         setOffsetTopA(center + 250);
         setOffsetTopB(center + 250);
       }
     };
     const el = scrollContainerRef.current;
     el.addEventListener("scroll", handleScroll);
     handleScroll();
     return () => el.removeEventListener("scroll", handleScroll);
   }, []);
 
   const handleSelectAll = (key, value) => {
     const all = allColumnValues(key);
     setTempSelectedValues((prev) => ({ ...prev, [key]: value ? all : [] }));
   };
 
   const toggleSelection = (key, value) => {
     setTempSelectedValues((prev) => {
       const list = prev[key] || [];
       return {
         ...prev,
         [key]: list.includes(value) ? list.filter((v) => v !== value) : [...list, value],
       };
     });
   };

   const resetAll = () => {
    setSelectedValues({});
    setTempSelectedValues({});
    setSearchText({});
    setSortColumn("workstream_type");
  }; 
 
  const applyFilter = (key) => {
    setSelectedValues((prev) => ({ ...prev, [key]: tempSelectedValues[key] || [] }));
    setFilterModal((prev) => ({ ...prev, [key]: false }));
  };
 
   const renderFilterModal = (key, label) => {
     //const allValues = allColumnValues(key);
    // const allValues = [...new Set(filteredData.map((item) => item[key]).filter(Boolean))];
    const allValues = [
      ...new Set(
        filteredData
          .map((item) => item[key]?.toString().trim())
          .filter(Boolean)
      )
    ];
     const search = searchText[key] || "";
     const filtered = (allValues || []).filter((val) =>
       val.toString().toLowerCase().includes(search.toLowerCase())
     ).sort((a, b) => a.toString().localeCompare(b.toString()));
     //const selected = tempSelectedValues[key] || [];
     const selected = (tempSelectedValues[key] || []).filter(val =>
      allValues.includes(val)
    );
 
     return (
       <div className="position-absolute bg-white border p-2 z-3" style={{ minWidth: "200px" }}>
         <input
           type="text"
           className="form-control mb-2"
           placeholder={`Search ${label}`}
           value={search}
           onChange={(e) => setSearchText((prev) => ({ ...prev, [key]: e.target.value }))}
         />
         <div className="form-check mb-1">     
           <input
             type="checkbox"
             className="form-check-input"
             checked={selected.length === allValues.length}
             onChange={(e) => handleSelectAll(key, e.target.checked)}
           />
            <label className="form-check-label"> Select All </label>
         </div>
         <div style={{ maxHeight: '150px', overflowY: "auto" }}>
           {filtered.map((val) => (
             <label key={val} style={{ display: "block", marginLeft:'2px'}} className="form-check-label">
               <input
                 type="checkbox"
                 className="form-check-input"
                 checked={selected.includes(val)}
                 onChange={() => toggleSelection(key, val)}
                 style={{ marginRight: '2px'}}
               />
               {val}
             </label>
           ))}
         </div>
         <div className="mt-2 d-flex justify-content-end gap-2">
         <button className="btn btn-sm btn-secondary" onClick={() => setFilterModal((prev) => ({ ...prev, [key]: false }))}>Close</button>
         <button className="btn btn-sm btn-primary" onClick={() => applyFilter(key)}>
           Apply
         </button>
       </div>
       </div>
     );
   };
 
   return (
     <div className="row" >
       <div>
         <div className="mb-1">
         <div className="float-start">
           <h6>{tableTitle}</h6>
         </div>
         <div className="float-end d-flex align-items-center mb-3">
          <button className="btn-reset" onClick={resetAll}>Reset Filter</button>
         <label className="form-label me-2 mb-0 fw-bold fs-14">Sort by:</label>
         <select className="form-select w-auto fs-14" value={sortColumn} onChange={(e) => setSortColumn(e.target.value)}>
           <option value="">-- Select Column --</option>
           {columns.map((col) => (
             <option key={col.key} value={col.key}>{col.label}</option>
           ))}
         </select>
         </div>
         </div>
       </div>
        <div    ref={scrollContainerRef}
       style={{ height: "450px", overflow: "auto", padding: "10px", position: "relative" }}
    >
       <table className="table table-bordered deliveryTable smart-table">
         <thead style={{ position: "sticky", top: '-15px', zIndex: 5 }}>
           <tr>
             {columns.map(({ key, label }) => (
               <th key={key}>
                 {label}
                 <i className="bi bi-filter" style={{ width: "16px", height: "16px", cursor: "pointer" }} 
                  onClick={() => setFilterModal((prev) => ({ ...prev, [key]: !prev[key] }))}
                  ></i> 
                 {filterModal[key] && renderFilterModal(key, label)}
               </th>
             ))}
             <th className={showA?"selected-bg":"white-bg"}></th>
             {showA && <th>Definition{" "}              </th>}
               {showA && <th>Formula{" "}  
                  {filterModal['formula'] && renderFilterModal('formula', 'Formula')}
               </th>}
             <th className={showB?"selected-bg":"white-bg"}></th>
             {showB && <th>Threshold Type{" "} <i className="bi bi-filter" style={{ width: "16px", height: "16px", cursor: "pointer" }} 
                  onClick={() => setFilterModal((prev) => ({ ...prev, ['threshold_type']: !prev['threshold_type'] }))} ></i> 
                  {filterModal['threshold_type'] && renderFilterModal('threshold_type', 'Threshold Type')} </th>}
             {showB && <th>Threshold 1{" "}  
              </th>}
             {showB && <th>Threshold 2{" "}  
                  </th>}
             {showB && <th>Threshold 3{" "}  
                  </th>}
             {showB && <th>Unit{" "} <i className="bi bi-filter" style={{ width: "16px", height: "16px", cursor: "pointer" }} 
                  onClick={() => setFilterModal((prev) => ({ ...prev, ['unit']: !prev['unit'] }))} ></i> 
                  {filterModal['unit'] && renderFilterModal('unit', 'Unit')} </th>}
             {showB && <th>Sourcing{" "} <i className="bi bi-filter" style={{ width: "16px", height: "16px", cursor: "pointer" }} 
                  onClick={() => setFilterModal((prev) => ({ ...prev, ['sourcing']: !prev['sourcing'] }))} ></i> 
                  {filterModal['sourcing'] && renderFilterModal('sourcing', 'Sourcing')}</th>}
           </tr>
         </thead>
         <tbody>
           {filteredData.map((item, index) => {
             const isFirstRow = index === 0;
             return (
               <tr key={index} className={filteredData.length<2?'min-height':''}>
                 {columns.map(({ key }) => (
                   <td key={key}>{item[key]}</td>
                 ))}
 
                 {isFirstRow && (
                   <td className={showA?"selected-bg":"white-bg"} rowSpan={filteredData.length} style={{ position: "relative", padding: 0 }}>
                     <div 
                       onClick={toggleA}
                       style={{
                         position: "absolute",
                         top: filteredData.length<3 ?0:offsetTopA,
                         left: 0,
                         right: 0,
                         margin: "auto",
                         writingMode: "vertical-rl",
                         transform: "rotate(180deg)",
                         textAlign: "center",
                         fontWeight: "bold",
                         cursor: "pointer",
                         padding: "8px 4px",
                         minHeight: "60px",
                         zIndex: 1,
                       }}
                     >
                       Metrics Definition &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;⮟ 
                     </div>
                   </td>
                 )}
                 {showA && <td>{item.definition}</td>}
                 {showA && <td>{item.formula}</td>}
 
                 {isFirstRow && (
                   <td  className={showB?"selected-bg":"white-bg"} rowSpan={filteredData.length} style={{ position: "relative", padding: 0 }}>
                     <div 
                       onClick={toggleB}
                       style={{
                         position: "absolute",
                         top: filteredData.length<3 ?0:offsetTopB,
                         left: 0,
                         right: 0,
                         margin: "auto",
                         writingMode: "vertical-rl",
                         transform: "rotate(180deg)",
                         textAlign: "center",
                         fontWeight: "bold",
                         cursor: "pointer",
                         padding: "8px 4px",
                         minHeight: "60px",
                         zIndex: 1,
                       }}
                     >
                       Metrics Threshold &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;⮟
                     </div>
                   </td>
                 )}
                 {showB && <td>{item.threshold_type}</td>}
                 {showB && <td>{item.threshold_1}</td>}
                 {showB && <td>{item.threshold_2}</td>}
                 {showB && <td>{item.threshold_3}</td>}
                 {showB && <td>{item.unit}</td>}
                 {showB && <td>{item.sourcing}</td>}
               </tr>
             );
           })}
         </tbody>
       </table>
       </div>
     {/* </div> */}
     </div>
   );
 };
 
 const DeliveryMetrics = () => {
   const [activeTab, setActiveTab] = useState("tab1");
   const [loading, setLoading] = useState(true);
   const [error, setError] = useState("");
   const [waterfall, setWaterfall] = useState([]);
   const [agile, setAgile] = useState([]);
   const [maintenance, setMaintenance] = useState([]);
   const [infrastructure, setInfrastructure] = useState([]);
   const [operations, setOperations] = useState([]);
   const [resource , setResource ] = useState([]);
   const [security  , setSecurity  ] = useState([]);
   const [kt  , setKt  ] = useState([]);
   const [testing  , setTesting  ] = useState([]);
   const navigate = useNavigate();
   const { userId } = useContext(UserContext);
   const [showFeedback, setShowFeedback] = useState(true);

     
   const apiUrl = CONFIG.REACT_APP_BACKEND_URL+'/query';
 
   useEffect(() => { 
     if(userId){      
    const postData={
     "query": "all the records",
     "all_data": true,
     "enterprise_id":userId
    };
    try {
    axios.post(apiUrl,postData)
     .then(response => {
       setLoading(false);
       console.log('response',response.data.result);
       if(response && response?.data?.result){
         if(response.data.result['Application Development - Waterfall'])
           setWaterfall(response.data.result['Application Development - Waterfall']);        
         if(response.data.result['Application Development - Agile'])
           setAgile(response.data.result['Application Development - Agile']);
         if(response.data.result['Application Maintenance'])
           setMaintenance(response.data.result['Application Maintenance']);
         if(response.data.result['Infrastructure Service'])
           setInfrastructure(response.data.result['Infrastructure Service']);
         if(response.data.result['Operations'])
           setOperations(response.data.result['Operations']);
         if(response.data.result['Operations'])
           setResource(response.data.result['Resource and Financial Metrics']);
         if(response.data.result['Security Service'])
           setSecurity(response.data.result['Security Service']);
 
         const totalData = Object.values(response.data.result)
           .flat() // merge all arrays into one
         const ktData= totalData.filter(obj => obj.delivery_function === 'Service Transition');
         setKt(ktData);
         console.log('kt',ktData);
         const testData= totalData.filter(obj => obj.delivery_function === 'Test Execution');
         setTesting(testData);
         console.log('testData',testData);  
       }
     })
     .catch(error => {
        if(error?.response?.data?.error){
          navigate(`/erroraccessdm`);     
       }
     })
   } catch (err) {
     setError("Failed to fetch data.");
   } finally {
     setLoading(true);
   }
 }
   }, [userId]);
 
   const columns = [
     { key: "metric_name", label: "Metric Name" },
     { key: "workstream_type", label: "Workstream Type" },
     { key: "delivery_function", label: "Delivery Function" },
     { key: "category", label: "Category" },
     { key: "applicability", label: "Applicability" }
   ];
   if (error) { navigate(`/error`) }
 
   return (
   <div>
             <Navbar subModule='Delivery Metrics'/>      
       {/* <div className='projectHeader' id="projectHeader"> */}
        
       <div className="deliveryMertics">
         {/* <div className='projectHeader' id="projectHeader"> */}
         <ul className="nav nav-pills mb-3  displayTab flex-wrap" style={{ display: 'flex', flexWrap: 'nowrap', overflowX: 'auto', whiteSpace: 'nowrap' }}>      
         <li className="nav-item me-0" key="tab1">
             <button
               className={`nav-link ${activeTab === "tab1" ? "active nav-link w-100 text-truncate" : "nav-link w-100 text-truncate"}`}
               onClick={() => setActiveTab("tab1")}
             >
               Application Development Waterfall
             </button>
           </li>
         <li className="nav-item me-0" key="tab2">
             <button
               className={`nav-link ${activeTab === "tab2" ? "active nav-link w-100 text-truncate" : "nav-link w-100 text-truncate"}`}
               onClick={() => setActiveTab("tab2")}
             >
               Application Development Agile
             </button>
           </li>
         <li className="nav-item me-0" key="tab3">
             <button
               className={`nav-link ${activeTab === "tab3" ? "active nav-link w-100 text-truncate" : "nav-link w-100 text-truncate"}`}
               onClick={() => setActiveTab("tab3")}
             >
               Application Maintenance
             </button>
           </li>
         <li className="nav-item me-0" key="tab9">
             <button
               className={`nav-link ${activeTab === "tab9" ? "active nav-link w-100 text-truncate" : "nav-link w-100 text-truncate"}`}
               onClick={() => setActiveTab("tab9")}
             >
               Infrastructure Service
             </button>
           </li>
         <li className="nav-item me-0" key="tab4">
             <button
               className={`nav-link ${activeTab === "tab4" ? "active nav-link w-100 text-truncate" : "nav-link w-100 text-truncate"}`}
               onClick={() => setActiveTab("tab4")}
             >
               Knowledge Transfer
             </button>
           </li>
         <li className="nav-item me-0" key="tab5">
             <button
               className={`nav-link ${activeTab === "tab5" ? "active nav-link w-100 text-truncate" : "nav-link w-100 text-truncate"}`}
               onClick={() => setActiveTab("tab5")}
             >
               Resources and Financial
             </button>
           </li>
         <li className="nav-item me-0" key="tab6">
             <button
               className={`nav-link ${activeTab === "tab6" ? "active nav-link w-100 text-truncate" : "nav-link w-100 text-truncate"}`}
               onClick={() => setActiveTab("tab6")}
             >
               Testing
             </button>
           </li>
         <li className="nav-item me-0" key="tab7">
             <button
               className={`nav-link ${activeTab === "tab7" ? "active nav-link w-100 text-truncate" : "nav-link w-100 text-truncate"}`}
               onClick={() => setActiveTab("tab7")}
             >
               Operations
             </button>
           </li>
         <li className="nav-item me-0" key="tab8">
             <button
               className={`nav-link ${activeTab === "tab8" ? "active nav-link w-100 text-truncate" : "nav-link w-100 text-truncate"}`}
               onClick={() => setActiveTab("tab8")}
             >
               Security Service
             </button>
           </li>
       </ul>
       </div>
       {/* </div> */}
       <div className="tabDisplay">
       {activeTab === "tab1" &&  <TableWithSortAndColBorders tableTitle='Application Development Waterfall Metrics' tableData={waterfall} columns={columns} /> }
       {activeTab === "tab2" &&  <TableWithSortAndColBorders tableTitle='Application Development Agile Metrics' tableData={agile} columns={columns} /> }
       {activeTab === "tab3" &&  <TableWithSortAndColBorders tableTitle='Application Maintenance Metrics' tableData={maintenance} columns={columns} /> }
       {activeTab === "tab4" &&  <TableWithSortAndColBorders tableTitle='Knowledge Transfer Metrics' tableData={kt} columns={columns} /> }
       {activeTab === "tab5" &&  <TableWithSortAndColBorders tableTitle='Resources and Financial Metrics' tableData={resource} columns={columns} /> }
       {activeTab === "tab6" &&  <TableWithSortAndColBorders tableTitle='Testing' tableData={testing} columns={columns} /> }
       {activeTab === "tab7" &&  <TableWithSortAndColBorders tableTitle='Operations Metrics' tableData={operations} columns={columns} /> }
       {activeTab === "tab8" &&  <TableWithSortAndColBorders tableTitle='Security Service Metrics' tableData={security} columns={columns} /> }
       {activeTab === "tab9" &&  <TableWithSortAndColBorders tableTitle='Infrastructure Service Metrics' tableData={infrastructure} columns={columns} /> } 
       <div className="downloadDiv fs-12">For more details <a href="/pdfs/ApplicabilityInfo.xlsx"  className="fs-12" download>download the metrics</a></div>
       {showFeedback && (<FeedbackWidget moduleName="DeliveryMetrics_Web" onSubmit={() => setShowFeedback(false)}/>)}
       </div>
      
      
       {/* </div> */}
       {loading && <Loader loadingtxt='Loading delivery metrics details, Please hold on a moment'/>} 
     </div>
   );
   
 };
 
export default DeliveryMetrics;
 